import { RouterProvider, createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultErrorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="p-8 font-mono text-sm">
      <h1 className="mb-2 font-semibold">Something broke</h1>
      <pre className="text-muted-foreground">{error.message}</pre>
    </div>
  ),
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export function App() {
  return (
    <RouterProvider
      router={router}
      defaultPendingComponent={() => (
        <div role="status" aria-label="Loading" className="text-muted-foreground p-8 text-sm">
          Loading…
        </div>
      )}
    />
  );
}
